import { SerializedStyles } from '@emotion/react'
import styled from '@emotion/styled'
import { base } from '../styles/spacing'
import CloseIcon from '@mui/icons-material/Close'

type ColorType = 'default' | 'bright' | 'dark' | 'outlined'

type TagProps = {
  small?: boolean
  rounded?: boolean
  color?: ColorType
  label: string
  styling?: SerializedStyles
  onRemove?: () => void
}

export const Tag = ({
  small = false,
  rounded = false,
  color = 'default',
  label,
  styling,
  onRemove,
}: TagProps) => (
  <StyledTag small={small} rounded={rounded} color={color} css={styling || ''}>
    <span>{label}</span>
    {onRemove && (
      <CloseIcon
        sx={{ fontSize: 14, marginLeft: `${base}px` }}
        onClick={onRemove}
      />
    )}
  </StyledTag>
)

const getBackgroundColor = (color: ColorType) => {
  switch (color) {
    case 'default':
      return 'var(--primary-1000)'
    case 'outlined':
      return 'var(--primary-200)'
    case 'bright':
      return 'var(--tertiary-1000)'
    default:
      return 'var(--primary-1000)'
  }
}

const getColor = (color: ColorType) => {
  switch (color) {
    case 'bright':
      return 'var(--primary-1000)'
    default:
      return 'var(--surface)'
  }
}

const getBorder = (color: ColorType) => {
  return 'none'
  // switch (color) {
  //   case 'default':
  //     return '1px solid var(--default-100)'
  //   case 'bright':
  //     return '1px solid var(--accent-light)'
  //   case 'dark':
  //     return '1px solid var(--primary-100)'
  //   case 'outlined':
  //     return '1px solid var(--secondary-1000)'
  // }
}

const StyledTag = styled.div<{
  small: boolean
  rounded: boolean
  color: ColorType
}>`
  font-family: 'Jokker';
  font-size: ${({ small }) => (small ? `${base * 3}px` : `${base * 3}px`)};
  background-color: ${({ color }) => getBackgroundColor(color)};
  border-radius: 8px;
  padding: ${({ small }) =>
    small ? `${base}px ${base * 2}px` : `${base}px ${base * 2}px`};
  color: ${({ color }) => getColor(color)};
  border: ${({ color }) => getBorder(color)};
  line-height: 1;
  display: flex;
  align-items: center;

  width: fit-content;

  span {
    display: inline-block;
    ::first-letter {
      text-transform: capitalize;
    }
  }
`
